/**
 * Builds a 195deg linear-gradient css value between two colors.
 */
function linearGradient(color, colorState, angle = 195) {
  return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
}

export default linearGradient;
